
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recommended",
      function () {
        return require("private-next-pages/recommended/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recommended"])
      });
    }
  